/**
 * Queued-mark counts per user, published by the outbox and read by the global offline banner
 * (FE-04 FR-FE04-29). Kept apart from `outbox.ts` so the root (and the pay page) never loads the
 * outbox code (FE-01 NFR-FE01-02).
 */
import { useSyncExternalStore } from "react";

let counts: Record<string, number> = {};
const listeners = new Set<() => void>();

export function publishPending(next: Record<string, number>): void {
  counts = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function usePendingCount(userId: string | undefined): number {
  return useSyncExternalStore(
    subscribe,
    () => (userId ? (counts[userId] ?? 0) : 0),
    () => 0,
  );
}
